import Api from 'api/v2/Api';
import axios from 'axios';

class FeedbackApi extends Api {
  /**
   * @param  {Object} payload [idea, priority]
   */
  postFeedback(payload) {
    return this.initialize()
      .then(() => axios.post('/feedback', payload));
  }
}

export default new FeedbackApi();
